import { styled } from '@linaria/react';

import { ButtonIconSecondary } from '~shared/ui/atoms/Buttons/ButtonSecondary/Icon';
import { MqTablet } from '~theme/media';

export const StyledSideMenuButton = styled(ButtonIconSecondary)`
	&& {
		display: none;
		${MqTablet} {
			display: inline-flex;
		}
	}
`;
